export default [
  {
    key: 'videoLink',
    label: 'field.videoEmbedLink',
    rules: 'required',
    type: 'text',
    cols: 12,
  },
]
